import { useEffect, useState } from 'react';
import { useParams } from "react-router-dom";
import { useSnackbar } from "notistack";
import { Paper, Button, Table, TableBody, TableCell, TableRow, Tooltip, Accordion, AccordionSummary, Typography, AccordionDetails, Checkbox, Grid, Box, TableHead, TableSortLabel, } from '@mui/material';
import { LeasesMenuList, LeasesNav } from '../../../elements';
import { MembersList, WorkingGroupCRU, membersObj } from '../components';
import { Restore as RestoreIcon, AttachFile as AttachFileIcon, Visibility as VisibilityIcon, Edit as EditIcon, Delete as DeleteIcon } from '@mui/icons-material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import MembersCRU from '../components/MembersCRU'
import { globalGetService, globalDeleteService } from '../../../../utils/globalApiServices';
import { getWorkingGroupApi, deleteMembersApi, deleteWorkingGroupApi, getWorkingGroupMemberApi } from '../apiService';
import { checkApiStatus, getGlobalCookie } from '../../../../utils';
import { PageLoader, STableLoader } from '../../../../shared_elements';
import { ShowAttachments, DeletePopUp, ButtonLoader, } from '../../../../shared_elements/components';
import NoRecordFound from '../../../../shared_elements/NoRecordFound';
import { PermissionWrapper } from '../../../../wrappers';
import { RoleBaseAccess } from '../../../../hoc';
import LeasesBasicDetails from '../../../elements/LeasesBasicDetails';
import { trackActivity } from '../../../../utils/mixpanel';
import RevisionHistory from '../../../../shared_elements/components/RevisionHistory';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import { useDispatch, useSelector } from 'react-redux';
import FileUploadLayout from '../../../../shared_elements/components/FileUploadLayout';
import fileUpload, { getApiResponse } from '../../../../utils/fileUpload';
import { getStorage } from '../../../../shared_elements/actionCreators';
import ModuleWiseRevisionHistory from '../../../../shared_elements/components/ModuleWiseRevisionHistory';
import UploadingIcon from '../../../../shared_elements/components/UploadingIcon';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import AuditPopover from '../../../../shared_elements/components/popover';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import BackToLeaseList from '../../../elements/BackToLeaseList';
import AddOutlinedIcon from '@mui/icons-material/AddOutlined';

const WorkingGroups = () => {
    const dispatch = useDispatch()
    const {fileUploadDetails} = useSelector((state) => state.leases);
    const { leaseSlug } = useParams();
    const params = { leaseSlug: leaseSlug }
    const { enqueueSnackbar } = useSnackbar()
    const [isLoading, setLoading] = useState(false)
    const [skeletonLoader, setSkeletonLoader] = useState(false)
    const [workingGroupInfo, setWorkingGroupInfo] = useState({ list: [], pagination: {}, })
    const [membrsSorting, setmembrsSorting] = useState({ list: [], pagination: {}, })
    const [workingGroupCRU, setWorkingGroupCRU] = useState({ modal: false, data: null, mode: '' })
    const [deleteWorkingGroup, setDeleteWorkingGroup] = useState({ modal: false, data: null })
    const [membersCRU, setMembersCRU] = useState({ modal: false, data: null, mode: '' })
    const [deleteMembers, setDeleteMembers] = useState({ modal: false, data: null, })
    const [bulk, setBulk] = useState({ modal: false, ids: [], title: '', type: '', activeGroup: '' })
    const [sortInfo, setSortInfo] = useState({ sort: '', sort_by: '' });
    const [attachments, setAttachments] = useState({ modal: false, data: null,module:"",mode:'' })
    const [revisionHistory, setRevisionHistory] = useState({ mode: '', modal: false, data: null,module:"" });
    const[isExport,seIsExport]=useState(false)
    const[uploadFileProgressData,setUploadFileProgressData]=useState({})
    const [uploadFileStatus, setUploadFileStatus] = useState({ mode: '', modal: false, data: null });
    const [slug,setSlug]=useState({})

    useEffect(() => {
        const uploadedFileData = getApiResponse("working_group", slug);
        getWorkingGroupList('skeletonLoader');
        trackActivity('Page Viewed', { page_title: 'Working Groups' })
        setUploadFileProgressData({ uploadedFileData });
    }, [])


    const getWorkingGroupList = (loaderType, query = {}) => {
        loaderType === 'skeletonLoader' ? setSkeletonLoader(true) : setLoading(true);
        globalGetService(getWorkingGroupApi(params, query))
            .then(response => {
                loaderType === 'skeletonLoader' ? setSkeletonLoader(false) : setLoading(false);
                if (checkApiStatus(response)) {
                    setWorkingGroupInfo(response.data.data);
                }
            })
        dispatch(getStorage({lease_slug:params?.leaseSlug,module_name:"working_group"}))
    }
    const getWorkingGroupMember = (query = {}, wkrgSlug) => {
        setLoading(true);
        globalGetService(getWorkingGroupMemberApi({ ...params, wrkSlug: wkrgSlug }, query))
            .then(response => {
                setLoading(false);
                if (checkApiStatus(response)) {
                    const { data = [] } = response.data;
                    setmembrsSorting(prev => ({
                        ...prev,
                        [wkrgSlug]: data
                    }));
                }
            })
    }

    const deleteWorkingGrpFn = () => {
        setLoading(true);
        globalDeleteService(deleteWorkingGroupApi(params), { ids: [deleteWorkingGroup?.data?.id] })
            .then(response => {
                if (checkApiStatus(response)) {
                    trackActivity('Item Deleted', { page_title: `Delete Working Group`, success_msg: response?.data?.message, item_ids: deleteWorkingGroup?.data, response: response?.data })
                    setDeleteWorkingGroup({ modal: false, data: null });
                    getWorkingGroupList('');
                    // setLoading(false);
                    enqueueSnackbar(response?.data?.message, { variant: "success", anchorOrigin: { horizontal: "right", vertical: "top" }, });
                } else {
                    setLoading(false);
                    enqueueSnackbar(response?.data?.message, { variant: "error", anchorOrigin: { horizontal: "right", vertical: "top" }, });
                    trackActivity('Item Deleted', { page_title: `Delete Working Group`, error_msg: response?.data?.message, item_ids: deleteWorkingGroup?.data, response: response?.data })
                }
            })
    }
    const deleteMembersFn = () => {
        const idsToDelete = deleteMembers?.modal && deleteMembers?.data?.id ? [deleteMembers?.data?.id] : (bulk?.ids || []).map(item => item?.id);
        setLoading(true);
        globalDeleteService(deleteMembersApi({ ...params, wrkGrpSlug: deleteMembers?.wrkGrpSlug || bulk?.wrkGrpSlug }), { ids: idsToDelete } )
            .then(response => {
                if (checkApiStatus(response)) {
                    trackActivity('Item Deleted', { page_title: `Delete Working Group Member`, success_msg: response?.data?.message, item_ids: deleteMembers?.data || bulk?.ids, response: response?.data })
                    if (sortInfo[deleteMembers?.wrkGrpSlug]?.sort) {
                        getWorkingGroupMember(sortInfo[deleteMembers?.wrkGrpSlug], deleteMembers?.wrkGrpSlug)
                    }
                    setDeleteMembers({ modal: false, data: null });
                    getWorkingGroupList('');
                    setBulk({ modal: false, ids: [], title: '', type: '', activeGroup: '', wrkGrpSlug: '' })
                    // setLoading(false);
                    enqueueSnackbar(response?.data?.message, { variant: "success", anchorOrigin: { horizontal: "right", vertical: "top" }, });
                } else {
                    setLoading(false);
                    enqueueSnackbar(response?.data?.message, { variant: "error", anchorOrigin: { horizontal: "right", vertical: "top" }, });
                    trackActivity('Item Deleted', { page_title: `Delete Working Group Member`, error_msg: response?.data?.message, item_ids: deleteMembers?.data || bulk?.ids, response: response?.data })
                }
            })
    }
    const toggleBulkOps = (flag, type, item, wrkg) => {
        if (type === 'bulk') {
            setBulk({ ...bulk, type: 'bulk', ids: flag ? item?.members : [], wrkGrpSlug: item?.slug, activeGroup: flag ? item?.slug : '' });
        } else {
            setBulk({ ...bulk, type: 'single', ids: flag ? [...bulk.ids, item] : bulk.ids.filter(optionItem => optionItem.id !== item.id), wrkGrpSlug: wrkg?.slug, activeGroup: wrkg?.slug || '' })
        }
    }
    const onDeteAttchments = (deltedslug) => {
        setAttachments({
            ...attachments, data: {
                ...attachments.data,
                attachments: attachments.data.attachments.filter(item => item.slug !== deltedslug)
            }
        });
        if (workingGroupCRU?.modal) {
            setWorkingGroupCRU({
                ...workingGroupCRU,
                data: {
                    ...workingGroupCRU.data,
                    attachments: workingGroupCRU.data.attachments.filter(item => item?.slug !== deltedslug)
                }
            })
        }
        if (membersCRU?.modal) {
            setMembersCRU({
                ...membersCRU,
                data: {
                    ...membersCRU.data,
                    attachments: membersCRU.data.attachments.filter(item => item?.slug !== deltedslug),
                    emails_list: membersCRU?.membersCRU ? membersCRU?.membersCRU?.email?.split(',') : [],
                }
            })
        }
        getWorkingGroupList('');
    }

    const createSortHandler = (key, wkrgSlug) => {
        const currentSort = sortInfo[wkrgSlug] || {};
        let newSort = { sort_by: key };

        if (currentSort.sort_by === key) {
            newSort.sort = currentSort.sort === 'asc' ? 'desc' : 'asc';
        } else {
            newSort.sort = 'asc';
        }
        setSortInfo(prev => ({ ...prev, [wkrgSlug]: newSort }));
        getWorkingGroupMember({ ...newSort }, wkrgSlug);
    };

    const tableSorting = (key, name, wkrgSlug) => {
        const groupSort = sortInfo[wkrgSlug] || {};
        return (
            <TableSortLabel
                active={groupSort.sort_by === key}
                direction={groupSort.sort_by === key ? groupSort.sort : 'asc'}
                onClick={() => {createSortHandler(key, wkrgSlug);handleItemClicked(`Table Sorting: ${name}`)}}
            >
                {name}
            </TableSortLabel>
        )
    }

    const handleExport=()=>{
        seIsExport(true);
        globalGetService(getWorkingGroupApi(params , { export: true})).then((response)=>{
            if (checkApiStatus(response)){
              enqueueSnackbar(
                     response?.data.message,
                     { variant: "success", anchorOrigin: { vertical: "top", horizontal: "right" } }
                   );
                    seIsExport(false);
            }
        })
    }

    const handleItemClicked = (page_type) => {
        trackActivity('Item Clicked', { page_title: 'Working Groups', page_type: page_type, })
    }

    const handleUpload = async (slug,mode) => {
        setSlug({slug:slug})
      await fileUpload({
      attachments: fileUploadDetails.attachments,
      module_name: membersCRU?.type === "member_list" ? "working_group_member":"working_group",
      slug: slug,
      query: { record_action_type: mode },
    //   onStart: () => setLoading(true),
      onComplete: () => setLoading(false),
      onProgress: ({ progressRefs, attachments ,response}) => {
         setUploadFileProgressData({ progressRefs, attachments ,response});
     },
     onSuccess: (success_msg) => {
      enqueueSnackbar(success_msg, {
        variant: "success",
        anchorOrigin: { vertical: "top", horizontal: "right" }
      });
       getWorkingGroupList("", { per_page: 20 });
     },
     onError: (err) => {
      enqueueSnackbar(`${err?.message}` || "Error while uploading files", {
        variant: "error",
        anchorOrigin: { vertical: "top", horizontal: "right" }
      });
     }
     });
       setSlug({})
    };  

    const activeGroupMembersCount = workingGroupInfo?.list?.find((group) => group?.slug === bulk?.activeGroup)?.members?.length || 0;
    const isAllMembersSelectedInActiveGroup = bulk?.ids?.length > 0 && bulk?.ids?.length === activeGroupMembersCount;

    return (
        <>
            <LeasesBasicDetails />
            <Paper className='lease-details-section section-overflow lease-module-paper' elevation={0}>
                <LeasesNav type="basic" />
                <div className='lease-details-content contnet-overflow'>
                    <Paper square className="responsive-paper">
                        <Grid container className="responsive-grid" alignItems='flex-end'>
                            <Grid item size={{ md: 12, xs: 12 }} className="menu-container">
                                <LeasesMenuList btnText="Working Groups" type="basic" />
                            </Grid>
                            <Grid item size={{ md: 8, xs: 12 }} className="menu-container">
                                <BackToLeaseList />
                            </Grid>
                            <Grid item size={{ md: 4, xs: 12 }}>
                                <ul className='list-inline lease-details-right-items lease-details-btn' style={{ padding: '0px', float: 'right' }}>
                                    <li className='lease-mobile-button revision-history'><ModuleWiseRevisionHistory ViewGlobalHistory={() => setRevisionHistory({ modal: true, mode: '', data: { slug: params?.leaseSlug, type: "global" } })} /> </li>
                                    {workingGroupInfo?.list?.length > 0 ? <li className='lease-mobile-button'> <Button startIcon={isExport ? <ButtonLoader size={15} /> : <ArrowDownwardIcon />} onClick={() => { handleExport(); handleItemClicked('Export Button') }} variant="outlined" size='small' className='btn-primary action-btn-start-icon'> Export </Button> </li> : null}
                                    <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "working_groups", operationType: ['C'] }}>
                                        <li className='lease-mobile-button'> <Button startIcon={<AddOutlinedIcon />} variant="contained" color="primary" size='small' className='btn-primary action-btn-start-icon' onClick={() => { setWorkingGroupCRU({ modal: true, data: { name: "" }, mode: 'add', type: 'Working Groups' }); handleItemClicked('Add Item Button') }} > Add Working Group</Button></li>
                                    </PermissionWrapper>
                                </ul>
                            </Grid>
                        </Grid>
                    </Paper>
                        <Paper className='lease-detail-table working-groups-container lease-module-paper' elevation={0}>
                            {skeletonLoader ? <STableLoader count={5} rowCount={11} /> : (<>
                                {workingGroupInfo?.list?.length>0 ?workingGroupInfo?.list?.map((item, index) => {
                                      const uploadedFileData = getApiResponse("working_group", item?.slug);
                                    return (
                                    <div style={{ marginBottom: "2px" }} square>
                                    <Accordion key={item?.id} elevation={4} square >
                                        <AccordionSummary
                                            expandIcon={<ExpandMoreIcon />}
                                            aria-controls="panel1-content"
                                            id="panel1-header"
                                        >
                                            <Grid container direction="row" sx={{ justifyContent: "space-between", alignItems: "center", width: "100%", }}>
                                                <Grid> <Typography component="span">{item?.name}</Typography></Grid>
                                                <Grid sx={{ marginTop: '4px' }}>
                                                        <Box className="table-icon-container" onClick={(e) => e.stopPropagation()}>
                                                            <AuditPopover item={item}>
                                                                <MoreVertIcon fontSize="small" color="primary" sx={{ cursor: "pointer" }} />
                                                            </AuditPopover>
                                                            <Tooltip title="Revision History"><RestoreIcon className='revision-history' onClick={() => {setRevisionHistory({ modal: true, data: item, mode: 'view' ,module:"Working Groups"});handleItemClicked('RevisionHistoryIcon')}} fontSize="small" color="primary" /></Tooltip>

                                                                <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "working_groups", operationType: ['C'] }}>
                                                                    <Tooltip title="Add Member"><AddCircleOutlineIcon fontSize="small" color="primary" onClick={() => {setMembersCRU({ modal: true, data: membersObj, mode: 'add', wrkGrpSlug: item?.slug ,type:"member_list"});handleItemClicked('Add Member Button')}} sx={{fontSize: '18px'}}/></Tooltip>
                                                                </PermissionWrapper>

                                                            <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "working_groups", operationType: ['R'] }}>
                                                                <Tooltip title="View"> <VisibilityIcon fontSize="small" color="primary" onClick={(e) => { setWorkingGroupCRU({ modal: true, data: item, mode: 'view' }); e.stopPropagation();handleItemClicked('ViewIcon') }} sx={{mt: "5px"}} /> </Tooltip>
                                                            </PermissionWrapper>
                                                            <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "working_groups", operationType: ['U'] }}>
                                                                <Tooltip title="Edit"> <EditIcon color="primary" onClick={(e) => { setWorkingGroupCRU({ modal: true, data: item, mode: 'edit' }); e.stopPropagation();handleItemClicked('EditIcon') }} sx={{fontSize: '18px', mt: "5px"}} /> </Tooltip>
                                                            </PermissionWrapper>
                                                            <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "working_groups", operationType: ['D'] }}>
                                                                <Tooltip title="Delete"> <DeleteIcon color="error" onClick={(e) => { setDeleteWorkingGroup({ modal: true, data: item }); e.stopPropagation();handleItemClicked('DeleteIcon') }} sx={{mt: "5px", fontSize: "18px"}} /> </Tooltip>
                                                            </PermissionWrapper>
                                                            <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "working_groups", operationType: ['R'] }}>
                                                            {
                                                                item?.attachments?.length > 0 && (
                                                                    <Tooltip title="Attached File(s)">
                                                                        <Box className="attachment-container">
                                                                            <AttachFileIcon  color="primary" onClick={(e) => { setAttachments({ modal: true, data: item,module:"Working Groups" }); e.stopPropagation();handleItemClicked('AttachmentsIcon') }} sx={{ cursor: "pointer", fontSize: "18px" }} />
                                                                            <Box className="attachment-count">({item.attachments.length})</Box>
                                                                        </Box>
                                                                    </Tooltip>
                                                                )
                                                            }
                                                            </PermissionWrapper>

                                                         {  (slug?.slug === item?.slug) && <UploadingIcon viewFileStatus={() => setUploadFileStatus({ modal: true, data: uploadedFileData, mode: 'view' })}/> }
                                                            
                                                        </Box>
                                                </Grid>
                                            </Grid>
                                        </AccordionSummary>
                                        <AccordionDetails sx={{ padding: '0px' }}>
                                            <Grid container spacing={2} style={{ textAlign: 'right', margin: '5px' }}>
                                                    <Grid size={{ xs: 12, md: 12 }}>
                                                            {bulk?.type && bulk?.ids?.length > 0 && bulk?.activeGroup === item?.slug ? <><Tooltip title='Cancel' arrow><Button onClick={() => {setBulk({ modal: false, ids: [], title: '', type: '' });handleItemClicked('Bulk Delete Cancel Button')}} size="small" variant="outlined" color="primary" >Cancel</Button></Tooltip>
                                                        <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "working_groups", operationType: ['D'] }}>
                                                                <Button onClick={() => {setBulk({ ...bulk, title: 'Delete', modal: true });handleItemClicked('Bulk Delete Button')}} size="small" variant="contained" color="error" style={{ marginInline: '9px' }}>
                                                                    Delete ({bulk?.ids?.length})
                                                                </Button>
                                                        </PermissionWrapper>
                                                            </>
                                                                : null}
                                                        {/* <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "working_groups", operationType: ['C'] }}>
                                                            <Button variant="contained" color="primary" size='small' className='btn-primary' onClick={() => {setMembersCRU({ modal: true, data: membersObj, mode: 'add', wrkGrpSlug: item?.slug ,type:"member_list"});handleItemClicked('Add Member Button')}} > Add Member </Button>
                                                        </PermissionWrapper> */}
                                                    </Grid>
                                            </Grid>
                                            <div style={{ overflowX: 'auto' }}>
                                                <Table className='mui-table-format' stickyHeader>
                                                    <TableHead>
                                                        <TableRow>
                                                            <TableCell className="table-actions-header" >
                                                                <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "working_groups", operationType: ['D'] }}>
                                                                     <Checkbox color="primary" size="small" onChange={(e) => toggleBulkOps(e.target.checked, 'bulk', item, item)} checked={item?.members?.length === bulk?.ids?.length && item?.members?.length > 0 && bulk?.activeGroup === item?.slug} /> 
                                                                        </PermissionWrapper>
                                                                        Action(s) 
                                                            </TableCell>
                                                            <TableCell sx={{ minWidth: "140px" }}> {tableSorting('first_name', 'First Name', item?.slug)}  </TableCell>
                                                            <TableCell sx={{ minWidth: "140px" }}> {tableSorting('last_name', 'Last Name', item?.slug)}  </TableCell>
                                                            <TableCell sx={{ minWidth: "140px" }}> {tableSorting('email', 'Email Address', item?.slug)}</TableCell>
                                                            <TableCell sx={{ minWidth: "140px" }}> {tableSorting('mobile', 'Mobile Number', item?.slug)}</TableCell>
                                                            <TableCell sx={{ minWidth: "140px" }}> {tableSorting('designation', 'Designation', item?.slug)}</TableCell>
                                                            <TableCell sx={{ minWidth: "140px" }}> {tableSorting('remarks', 'Remarks', item?.slug)}</TableCell>
                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                        {item?.members?.length > 0 && (membrsSorting[item?.slug]?.list?.length ? membrsSorting[item?.slug]?.list : item?.members)?.map((member, index) => {
                                                                    const uploadedFileData = getApiResponse("working_group", member?.slug);

                                                            return (
                                                                <MembersList
                                                                    slug={slug?.slug}
                                                                    uploadedFileData={uploadedFileData }
                                                                    uploadFileProgressData={uploadFileProgressData}
                                                                    viewFileStatus={(uploadedFileData) => setUploadFileStatus({ modal: true, data: uploadedFileData, mode: 'view' })}
                                                                    key={index}
                                                                    item={member}
                                                                    bulk={bulk}
                                                                    viewRevisonHistory={(member) => setRevisionHistory({ modal: true, data: member, mode: 'view' })}
                                                                    onEditFn={() => setMembersCRU({ modal: true, data: member, mode: 'edit', wrkGrpSlug: item?.slug , type:"member_list"})}
                                                                    onView={() => setMembersCRU({ modal: true, data: member, mode: 'view' })}
                                                                    onDeleteMember={() => {
                                                                        setBulk({ modal: false, ids: [member], title: '', type: '', activeGroup: item?.slug, wrkGrpSlug: item?.slug });
                                                                        setDeleteMembers({ modal: true, data: member, wrkGrpSlug: item?.slug });
                                                                    }}
                                                                    toggleBulkOps={(e) => toggleBulkOps(e.target.checked, 'single', member, item)}
                                                                    onOpenAttachments={() => setAttachments({ modal: true, data: member,module:"Working Groups Member" })}
                                                                />
                                                            )
                                                        })
                                                        }
                                                    </TableBody>
                                                </Table>
                                                {item?.members?.length === 0 && <NoRecordFound />}
                                            </div>
                                        </AccordionDetails>
                                    </Accordion>
                                </div>
                                    )
                                 }
                            ) : <Paper square><Box sx={{ textAlign: "center", color: "var(--primary-color)", fontSize: "13px", fontWeight: "500", backgroundColor: "#e6ebfb", padding: 1, }}>No Record Found</Box></Paper>
                                }

                                 </>)}
                        </Paper>
                    </div>
            </Paper>
                {workingGroupCRU?.modal ?
                    <WorkingGroupCRU
                        fileUpload={handleUpload}
                        modeType={workingGroupCRU?.mode}
                        workingGrpCRU={workingGroupCRU}
                        getResponseBack={() => getWorkingGroupList('')}
                        onToggleModal={() => setWorkingGroupCRU({ modal: false, data: null, mode: '',type:"Working Groups" })}
                        onOpenAttachments={() => setAttachments({ modal: true, data: workingGroupCRU?.data, mode:'view' })}
                    />
                    : null}
                {bulk.modal || deleteWorkingGroup.modal || deleteMembers.modal ?
                    <DeletePopUp
                        modal={bulk.modal ? bulk.modal : deleteWorkingGroup.modal ? deleteWorkingGroup.modal : deleteMembers?.modal}
                        title={bulk.modal ? `Delete ${isAllMembersSelectedInActiveGroup ? 'All Members' : 'Selected Members'}` : deleteWorkingGroup.modal ? 'Delete Working Group' : 'Delete Member'}
                        onDeleteRecords={() => bulk.modal || deleteMembers?.modal ? deleteMembersFn() : deleteWorkingGrpFn()}
                        content={bulk.modal ? `Are you sure, you want to Delete ${bulk?.ids.length > 1 ? 'these' : 'this'} record ?` : `Are you sure, you want to Delete?`}
                        onToggleModal={() => {
                            if (bulk.modal) {
                                setBulk({ modal: false, ids: [], title: '', type: '', activeGroup: '', wrkGrpSlug: '' });
                            } else if (deleteWorkingGroup.modal) {
                                setDeleteWorkingGroup({ modal: false, data: null });
                            } else {
                                setDeleteMembers({ modal: false, data: null });
                                setBulk({ modal: false, ids: [], title: '', type: '', activeGroup: '', wrkGrpSlug: '' });
                            }
                        }}
                    /> : null
                }
                {membersCRU?.modal ?
                    <MembersCRU
                        fileUpload={handleUpload}
                        membersCRU={membersCRU}
                        modeType={membersCRU?.mode}
                        wrkGrpSlug={membersCRU?.wrkGrpSlug}
                        sortInfo={sortInfo}
                        getSortingWiseData={(query, wkrgSlug) => getWorkingGroupMember(query, wkrgSlug)}
                        getResponseBack={() => getWorkingGroupList('')}
                        onOpenAttachments={() => setAttachments({ modal: true, data: membersCRU?.data, mode:'view' })}
                        onToggleModal={() => setMembersCRU({ modal: false, data: null, mode: '', wrkGrpSlug: null })}
                    /> : null
                }

                {attachments.modal ?
                    <ShowAttachments
                        moduleName={attachments.module}
                        url='delete-attachment'
                        attachmentsData={attachments}
                        getResponseBack={onDeteAttchments}
                        toggleModalFn={() => setAttachments({ modal: false, data: null, mode:'' })}
                        onViewDisabled={workingGroupCRU?.mode === 'view' || membersCRU?.mode === 'view' || attachments?.mode==='view'}
                        permissionKey="working_groups"
                    /> : null
                }
                {
                  revisionHistory.modal &&  
                  <RevisionHistory 
                   moduleName={revisionHistory?.data?.type === "global" || revisionHistory?.module === "Working Groups" ? "working_group":"working_group_member"}
                   revisionHistory={revisionHistory}
                   onToggleModal={() => setRevisionHistory({ modal: false, mode: '', data: null })}
                  />
                }
                <FileUploadLayout
                    uploadFileStatus={uploadFileStatus}
                    open={uploadFileStatus?.modal}
                    setUploadFileStatus={setUploadFileStatus}
                    uploadFileProgressData={uploadFileProgressData}
                    progressRefs={uploadFileProgressData?.progressRefs}
                    attachments={uploadFileProgressData?.attachments}
                    onDownloadComplete={()=> setSlug({})}
                />
                {isLoading ? <PageLoader /> : null}
        </>
    )

}

export default RoleBaseAccess(WorkingGroups, { application: 'lease_revamp', feature: 'working_groups', operationType: ['R'], leaseNav: true });
